module.exports = __webpack_public_path__ + "img/icp.c8c0a72b.png";